<app-leveltwo [videos]="true" [pageName]="'ADUs'">
    <div heading="General Info" class="General">
      <h3>{{'ADU.PageTitlev2'|translate}}</h3>

      <p>{{'ADU.anaccessoryv2'|translate}}</p>
      <ul>
        <li><p>{{'ADU.accessoryitem1'|translate}}</p></li>
        <li><p>{{'ADU.accessoryitem2'|translate}}</p></li>
        <li><p>{{'ADU.accessoryitem3'|translate}}</p></li>
        <li><p>{{'ADU.accessoryitem4'|translate}}</p></li>
        <li><p>{{'ADU.accessoryitem5'|translate}}</p></li>
        <li><p>{{'ADU.accessoryitem6'|translate}}</p></li>
      </ul>
      <h4>{{'ADU.junioradu'|translate}}</h4>
      <p>{{'ADU.junioradutext1v2'|translate}}<b> {{'ADU.lessthan500v2'|translate}}</b>{{'ADU.junioradutext2'|translate}}</p>

      <h4>{{'ADU.requirementsv2'|translate}}</h4>
      <p><b>{{'ADU.note'|translate}} </b>{{'ADU.notetext'|translate}}</p>





      <div class="row">
        <div class="col-md">
          <h5>{{'ADU.generalAduv2'|translate}}</h5>

          <ul>
            <li>{{'ADU.generalAdu1v2'|translate}}</li>
            <li>{{'ADU.generalAdu2v2'|translate}}</li>
            <li>{{'ADU.generalAdu3'|translate}}</li>
            <li>{{'ADU.generalAdu4'|translate}}</li>
            <li>{{'ADU.generalAdu5'|translate}}</li>
            <li>{{'ADU.generalAdu6'|translate}}</li>
            <li>{{'ADU.generalAdu7'|translate}}</li>
            <li>{{'ADU.generalAdu8'|translate}}</li>
          </ul>
        </div>
        <div class="col-md">
          <h5 id="NoUpper">{{'ADU.generalJaduv2'|translate}}</h5>
          <ul>
            <li>{{'ADU.generalJadu1'|translate}}</li>
            <li>{{'ADU.generalJadu2'|translate}}</li>
            <li>{{'ADU.generalJadu3'|translate}}</li>
            <li>{{'ADU.generalJadu4'|translate}}</li>
            <li>{{'ADU.generalJadu5'|translate}}</li>
            <li>{{'ADU.generalJadu6'|translate}}</li>
          </ul>
        </div>
      </div>

      <div class="accordion">
        <accordion [isAnimated]="true" >
        <accordion-group #drop [isOpen]="false">
          <div accordion-heading >
            <span class="dropdown-item clearfix">
              {{'ADU.Updates'|translate}} <i class="mt-1 float-end" [ngClass]="!drop.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
            </span>
          </div>

            <strong>SB 9 (2021)</strong><br>
            {{'ADU.MultipleUnits'|translate}}<br>
            <ul>
              <li>{{'ADU.Without'|translate}}</li>
              <li>{{'ADU.With'|translate}}</li>

            </ul>
            {{'ADU.Formore'|translate}}<a href="https://planning.lacity.org/development-services/senate-bill-9" target="blank">planning.lacity.org/development-services/senate-bill-9</a><br><br>


            <strong>AB 3182 (2020)</strong><br>
            <ul>
              <li>{{'ADU.Provides1'|translate}}</li>
              <li>{{'ADU.Provides2'|translate}}</li>
            </ul>

            <strong>AB 68, AB 881, and SB 13 (2019)</strong><br>
            <ul>
              <li>{{'ADU.Eliminates'|translate}}</li>
              <li>{{'ADU.Prohibits'|translate}}</li>
              <li>{{'ADU.Allows'|translate}}</li>
            </ul>

            <strong>AB 587 (2019)</strong><br>
            <ul>
              <li>{{'ADU.Creates'|translate}}</li>

            </ul>




        </accordion-group>
        </accordion>
        <p><i>{{'ADU.TheAssessor'|translate}}</i></p>
      </div>

    </div>

  <app-videos-grid class="Videos" [videos]="videos">
    <p style="color: black"><i>{{'ADU.TheAssessor'|translate}}</i></p>
  </app-videos-grid>



    <!-- <tab heading="FAQ">FAQ</tab>
    <tab heading="Forms">Forms</tab> -->
</app-leveltwo>
